<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      :breadcrumbs="breadcrumbs"
      icon="widgets"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row>
        <v-col cols="10" align="start">
          <div>
            <v-text-field
              v-model="order.name"
              class="mr-3 float-left"
              filled
              placeholder="Họ tên..."
              @input="debounceInputName"
            >
            </v-text-field>
            <v-text-field
              type="number"
              v-model="order.phone_number"
              class="mr-3 float-left"
              filled
              placeholder="Số điện thoại..."
              @input="debounceInputPhone"
            >
            </v-text-field>
            <v-text-field
              type="number"
              v-model="order.price_from"
              class="mr-3 float-left"
              filled
              @input="debounceInputFrom"
              placeholder="Giá từ..."
            >
            </v-text-field>

            <v-text-field
              type="number"
              v-model="order.price_to"
              class="mr-3 float-left"
              filled
              @input="debounceInputTo"
              placeholder="Giá đến..."
            >
            </v-text-field>
            <v-select
              class="mr-3 float-left"
              filled
              v-model="order.status"
              :items="this.status"
              item-text="text"
              item-value="value"
              @change="getItem"
              placeholder="Trạng thái đơn hàng"
            ></v-select>
               <v-select
              class="mr-3 float-left"
              filled
              v-model="order.delivery_type"
              :items="this.delivery"
              item-text="text"
              item-value="value"
              @change="getItem"
              placeholder="Hình thức giao hàng"
            ></v-select>
            <v-menu
              class="float-left"
              v-model="menu1"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  filled
                  class="mr-3 float-left"
                  v-model="dateStart"
                  label="Thời gian bắt đầu"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  @change="getItem"
                v-model="dateStart"
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
            <v-menu
              class="float-left"
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  filled
                  class="mr-3 float-left"
                  v-model="dateEnd"
                  label="Thời gian kết thúc"
                  append-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                  @change="getItem"
                v-model="dateEnd"
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
<!--            <v-btn height="49" color="primary" align="right" @click="getItem">-->
<!--              Search-->
<!--            </v-btn>-->
          </div>
        </v-col>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="oderSearches"
            :page.sync="page_number"
            :items-per-page="itemsPerPage"
            class="elevation-1"
            @page-count="pageCount = $event"
          >
            <template v-slot:item.price="{ item }">
              <span class="red--text">{{ item.price }}</span>
            </template>
            <template v-slot:item.created_at="{ item }">
              <span>{{ formatDate(item.created_at) }}</span>
            </template>

            <template v-slot:item.delivery_type="{ item }">
              <span v-if="item.delivery_type === 1">Nhận tại siêu thi</span>
              <span class="primary--text" v-else>Địa chỉ giao hàng</span>
            </template>

            <template v-slot:item.status="{ item }">
              <v-btn
                width="130"
                color="#F9FAD1"
                style="color: #a6a90d"
                class="text-none"
                v-if="item.status === 1"
                >Đã xác nhận</v-btn
              >
              <v-btn
                width="130"
                color="#CEC6EE"
                style="color: #1d067a"
                class="text-none"
                v-else-if="item.status === 2"
                >Đang giao hàng</v-btn
              >
              <v-btn
                width="130"
                color="#DCFDFD"
                style="color: #0097a7"
                class="text-none"
                v-else-if="item.status === 3"
                >Đã giao hàng</v-btn
              >
              <v-btn
                width="130"
                color="#FBCBCD"
                style="color: #db343b"
                class="text-none"
                 v-else-if ="item.status === 4"
                >Đã hủy</v-btn
              >
              <v-btn
                  width="130"
                  color="#DFDFDF"
                  class="text-none"
                  v-else
              >Chưa xác nhận</v-btn
              >
            </template>
            <template v-slot:item.total_price="{ item }">
              <div>
                {{ item && item.total_price ? formatCurrency(item.total_price): ''}}
              </div>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small @click="reviewItem(item)" v-if="hasPermissions('View order')"> mdi-eye </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import {GET_LIST_ORDER_SEARCH } from "@/store/modules/order";
import { mapGetters } from "vuex";
import {debounce} from "debounce";

export default {
  data() {
    return {
      current_page: 1,
      page_number: 1,
      pageCount: 0,
      itemsPerPage: 10,
      dateStart: "",
      dateEnd: "",
      menu: false,
      modal: false,
      menu1: false,
      menu2: false,
      page: "Quản lý Đơn hàng",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý đơn hàng",
          disabled: true,
        },
      ],
      order: [{ name: "" }, { status: "" }, { phone_number: null }, { price_from: null }, { price_to: null }, { delivery_type: null }],
      delivery: [
                {
          value: -1,
          text: "Chọn tất cả",
        },
        {
          value: 1,
          text: "Nhận tại siêu thị",
        },
        {
          value: 2,
          text: "Địa chỉ giao hàng",
        },
      ],

      status: [
        {
          value: -1,
          text: "Chọn tất cả",
        },
        {
          value: 1,
          text: "Đã xác nhận",
        },
        {
          value: 2,
          text: "Đang giao hàng",
        },
        {
          value: 3,
          text: "Đã giao hàng",
        },
        {
          value: 4,
          text: "Đã hủy",
        },
          {
          value: 0,
          text: "Chưa xác nhận",
        },
      ],

      headers: [
        { text: "ID", value: "id", align: "start" },
        { text: "Tên", value: "fullname" },
        { text: "Địa chỉ", value: "address" },
        { text: "SĐT", value: "phone" },
        { text: "Tổng tiền (vnđ)", value: "total_price" },
        { text: "Hình thức phục vụ", value: "delivery_type" },
        { text: "Trạng thái đơn hàng", value: "status" },
        { text: "Thời gian", value: "created_at" },
        { text: "Actions", value: "actions" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      orders: "orders",
      oderSearches: "oderSearches",
    }),
  },
  created() {
    this.page_number = parseInt(this.$route.query.page_current) || 1
    this.order.name =  this.$route.query.name || ''
    this.order.phone_number =  parseInt(this.$route.query.phone_number) || ''
    this.order.price_from = parseInt(this.$route.query.price_from) || ''
    this.order.price_to = parseInt(this.$route.query.price_to) || ''
    this.order.status = parseInt(this.$route.query.status) || ''
    this.order.delivery_type = parseInt(this.$route.query.delivery_type) || ''
    this.params();
  },
  methods: {
    formatCurrency(price) {
      const formatter = new Intl.NumberFormat('vi-VN', {
        style: 'currency',
        currency: 'VND',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
      return formatter.format(parseInt(price));
    },
    params() {
      let params = {
        name: this.order.name,
        time_start: this.dateStart,
        time_end: this.dateEnd,
        phone_number:this.order.phone_number,
        price_from: this.order.price_from,
        price_to : this.order.price_to,
        status: this.order.status != "-1" ? this.order.status : null,
        delivery_type: this.order.delivery_type != "-1" ? this.order.delivery_type : null,
      };
      this.$store.dispatch(GET_LIST_ORDER_SEARCH, params);
    },
    replaceOrder() {
      this.$router.replace({
        query: {
          name: this.order.name,
          time_start: this.dateStart,
          time_end: this.dateEnd,
          phone_number:parseInt(this.order.phone_number),
          price_from: parseInt(this.order.price_from),
          price_to : parseInt(this.order.price_to),
          status: this.order.status != "-1" ? this.order.status : null,
          delivery_type: this.order.delivery_type != "-1" ? this.order.delivery_type : null,
          page_current: parseInt(this.page_number),
        }
      })
    },
    debounceInputName: debounce(function (e) {
      this.order.name = e;
      this.replaceOrder();
      this.params();
    }, 200),

    debounceInputPhone: debounce(function (e) {
      this.order.phone_number = e;
      this.replaceOrder();
      this.params();
    }, 200),

    debounceInputFrom: debounce(function (e) {
      this.order.price_from = e;
      this.replaceOrder();
      this.params();
    }, 200),

    debounceInputTo: debounce(function (e) {
      this.order.price_to = e;
      this.replaceOrder();
      this.params();
    }, 200),

    getItem() {
      this.replaceOrder();
      this.params();
    },
    formatDate(date) {
      if (!date) return null;
      let newDate = new Date(date);
      const [year, month, day] = [
        newDate.getFullYear(),
        newDate.getMonth() + 1,
        newDate.getDate(),
      ];
      let day_format = day > 9 ? day : `0${day}`;
      let month_format = month > 9 ? month : `0${month}`;

      return `${day_format}/${month_format}/${year}`;
    },
    editItem() {},
    reviewItem(item) {
      this.replaceOrder();
      this.$router.push("/management_order/detail_order/" + item.id);
    },
    deleteItem() {},
    addNew() {
      this.$router.push("/manage_productions/production/addnew_production");
    },
  },
};
</script>
